var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"tc-page-title text-2xl leading-tight"},[_vm._t("default",[_c('span',{attrs:{"aria-hidden":"true"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }